import styled from "styled-components";

export const Wrapper = styled.div`
.filters{
.ant-select-selector, .ant-input-number-outlined {
    background: var(--app-surface) !important;
    color: var(--app-text) !important;
    border-color: var(--app-border) !important;
    min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
    color: var(--app-text) !important;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
    color: var(--app-text) !important;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height:12px;
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: var(--app-text-muted) !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    border:1px solid var(--app-border);
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
}
}

.add-alert {
  --add-alert-value-color: var(--app-text);
  --add-alert-placeholder-color: var(--app-text-muted);
  color: var(--app-text);

  .asin-scope-label,
  .fw-bold {
    color: var(--app-text) !important;
  }

  .asin-preset-pill {
    border-radius: 20px;
    padding: 5px 16px;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
    border: 1.5px solid var(--app-border);
    background: var(--app-surface-alt);
    color: var(--app-text-muted);
    cursor: pointer;
  }

  .asin-preset-pill:hover:not(:disabled) {
    border-color: #f45b68;
    color: #f45b68;
  }

  .asin-preset-pill--active {
    border-color: #f45b68 !important;
    background: #f45b68 !important;
    color: #ffffff !important;
    box-shadow: 0 2px 6px rgba(244, 91, 104, 0.25);
  }

  .verified-email-row {
    padding: 8px;
    border-radius: 4px;
    background: color-mix(in srgb, #52c41a 12%, var(--app-surface));
    border: 1px solid color-mix(in srgb, #52c41a 35%, var(--app-border));
    color: var(--app-text);
  }

  .add-alert-resend-link {
    color: color-mix(in srgb, #f45b68 55%, var(--app-text)) !important;
    padding: 0 !important;
  }

  .add-alert-resend-link:hover {
    color: #f45b68 !important;
  }

  .add-alert-asin-title,
  .add-alert-asin-sku {
    color: var(--app-text) !important;
  }

  .badge-light-danger {
    background: color-mix(in srgb, #f45b68 14%, var(--app-surface-alt)) !important;
    color: #f45b68 !important;
  }

  .ant-select-selector, .ant-input-number-outlined {
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    min-height: 42px;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper input,
  .ant-input-number-input,
  .ant-select-selection-item,
  .ant-select-selection-item-content,
  .ant-select-selection-search-input,
  .form-control.form-control-solid {
    color: var(--add-alert-value-color, var(--app-text)) !important;
    font-weight: 500;
  }

  .ant-input,
  .ant-input-affix-wrapper {
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
  }

  .ant-input-number .ant-input-number-input {
    padding: 9px 11px;
  }

  .ant-input::placeholder,
  .ant-input-affix-wrapper input::placeholder,
  .ant-select .ant-select-selection-placeholder {
    color: var(--add-alert-placeholder-color, var(--app-text-muted)) !important;
    font-weight: 400 !important;
    opacity: 0.85;
  }

  .ant-input[disabled],
  .ant-input-number-disabled .ant-input-number-input {
    background: var(--app-surface-alt) !important;
    color: var(--app-text-muted) !important;
    opacity: 0.7;
  }

  .ant-otp .ant-otp-input,
  .ant-otp-input {
    background: var(--app-surface) !important;
    color: var(--add-alert-value-color, var(--app-text)) !important;
    border: 1px solid #3f4254 !important;
    caret-color: var(--add-alert-value-color, var(--app-text));
  }

  .ant-otp .ant-otp-input:focus,
  .ant-otp-input:focus {
    border-color: #f45b68 !important;
    box-shadow: 0 0 0 2px rgba(244, 91, 104, 0.15) !important;
  }

  .ant-alert-description strong {
    color: var(--app-text);
  }

  .add-alert-cancel-btn,
  .ant-btn-default {
    background: var(--app-surface) !important;
    border: 1px solid #3f4254 !important;
    color: var(--app-text) !important;
  }

  .add-alert-cancel-btn:hover,
  .ant-btn-default:hover {
    background: color-mix(in srgb, var(--app-text) 8%, var(--app-surface)) !important;
    border-color: #3f4254 !important;
    color: var(--app-text) !important;
  }

  .ant-select-item {
    font-size: .95rem !important;
    font-weight: 500;
  }

  .ant-select .ant-select-arrow {
    height: 22px;
  }

  .ant-select .ant-select-selection-placeholder {
    font-size: 13px !important;
    font-weight: 400 !important;
  }

  .ant-picker-input input {
    font-size: 13px;
    color: var(--add-alert-value-color, var(--app-text)) !important;
  }

  .ant-picker-range {
    border: 1px solid var(--app-border);
  }

  .ant-select-multiple .ant-select-selection-item-content {
    font-size: 12px;
  }
}

[data-bs-theme="dark"] & .add-alert {
  --add-alert-value-color: #ffffff;
  --add-alert-placeholder-color: #92929F;
}
    .alert-read-row {
        background-color: var(--app-surface-alt) !important;
        opacity: 0.6;
    }

    .ant-table-row.alert-read-row {
        background-color: var(--app-surface-alt) !important;
        opacity: 0.6;
    }

    .text-two {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* white-space: pre-wrap; */
    width: 250px;
    margin-bottom: 0 !important;
  }
@media (max-width: 768px) {
    .filter {
        min-height: 70px;
        padding-left: 10px !important;
        padding-right: 10px !important;
        margin-right: -5px;
    }
}

/* Add to your Wrapper style component */
.filters-section {
    position: relative;
}

.filter-toggle-btn {
    transition: all 0.3s ease;
}

.filter-toggle-btn:hover {
    background-color: var(--app-surface-alt);
}

/* Optional: Add smooth transition for filter content */
.filters-section .filters {
    transition: all 0.3s ease;
}

/* Optional: Better mobile styling for select dropdowns */
@media (max-width: 768px) {
    .filters-section .ant-select {
        width: 100% !important;
    }
    
    .filters-section .ant-picker {
        width: 100% !important;
    }
}

`;